import { JSX } from 'react';
import { FeatureDiscovery, withProviders } from '@sdb/planning-ui';
import type { CustomFeatureDiscoveryOrganismPropTypes } from '@sdb/planning-ui/ui-3/products/planning/src/components/organisms/FeatureDiscovery/FeatureDiscovery.types';

export const FeatureDiscoveryWithProviders = withProviders<
  JSX.IntrinsicAttributes & CustomFeatureDiscoveryOrganismPropTypes
>(FeatureDiscovery);
